<template>
  <section class="f-33">
    <div ref="content" class="alive_content">
      <div class="title f-center-title">画面通透，更具个性</div>
      <div class="des f-center-sub-title">
        <div>用色更大胆，画面更通透，提升整体质感</div>
        <div>
          还增加了可个性化定义的桌面插件，用户可匹配不同风格的时间、天气插件
        </div>
      </div>
      <!-- 轮播图 -->
      <div class="f-select-center border_container_light slider_size" v-ia>
        <slider
          ref="slider"
          v-model:value="sliderActiveIndex"
          :controlBtn="false"
          :indicators="false"
          :autoplay="autoplay"
          :interval="1500"
          :touch="true"
          height="100%"
          width="100%"
        >
          <slider-item v-for="(i, index) in assetsList" :key="index">
            <m-img :src="i" />
          </slider-item>
        </slider>
      </div>
      <div class="alive_indicators">
        <div
          v-for="(i, index) in assetsList"
          class="slider_indicators"
          :class="`slider_indicators_${index} ${
            index === sliderActiveIndex && 'slider_indicators_active'
          }`"
          @click.passive="indicatorsClick(index)"
        ></div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      preload_: true,
      sliderActiveIndex: 0,
      autoplay: false,
      assetsList: [
        require('@/v2/auto/assets/image/33/0.jpg'),
        require('@/v2/auto/assets/image/33/1.jpg'),
        require('@/v2/auto/assets/image/33/2.jpg'),
        require('@/v2/auto/assets/image/33/3.jpg'),
      ],
    }
  },
  watch: {
    sliderActiveIndex(current) {
      this.$gsap.to(`.slider_indicators`, {
        width: 8,
        backgroundColor: '#00000024',
        duration: 0.5,
      })
      this.$gsap.to(`.slider_indicators_${current}`, {
        width: 34,
        backgroundColor: '#1368fb',
        duration: 0.5,
      })
    },
  },
  mounted() {
    this.$gsap.to(`.slider_indicators_${this.sliderActiveIndex}`, {
      width: 34,
      duration: 0,
    })
    this.$gsap.timeline({
      scrollTrigger: {
        trigger: this.$refs.content,
        onUpdate: (self) => {
          this.autoplay = self.isActive
          this.$refs.slider.auto()
          if (!self.isActive) {
            this.sliderActiveIndex = 0
          }
        },
      },
    })
  },
  methods: {
    sliderChange(index) {
      this.sliderActiveIndex = index
    },
    indicatorsClick(index) {
      this.sliderActiveIndex = index
    },
  },
}
</script>
<style lang="less" scoped>
.f-33 {
  width: 100%;
  position: sticky;
  z-index: 79;
  .alive_content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title {
      margin-top: 20px;
      font-weight: 250;
      display: flex;
      gap: 20px;
      // 设置背景
      background: radial-gradient(
        83.84% 58.59% at 49.68% 19.19%,
        #2e63ca 0%,
        #91a8e4 100%
      );
      // 背景作用于字体上
      background-clip: text;
      // 字体透明
      color: transparent;
      font-weight: 700;
    }
    .des {
      line-height: 1.6;
      margin: 30px 0;
      color: #00000080;
      text-align: center;
      width: 100%;
    }
    .slider_size {
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .alive_indicators {
      margin-top: 20px;
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 5px;
      height: 20px;
      .slider_indicators {
        width: 8px;
        height: 8px;
        background-color: #00000024;
        border-radius: 20px;
        cursor: pointer;
      }
      .slider_indicators_active {
        background-color: #1368fb;
      }
    }
  }
}
</style>
